import { render } from "./picture-in-picture.vue?vue&type=template&id=2f729e57"
import script from "./picture-in-picture.vue?vue&type=script&lang=js"
export * from "./picture-in-picture.vue?vue&type=script&lang=js"

import "./picture-in-picture.vue?vue&type=style&index=0&id=2f729e57&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__